import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import CartItemsInCart from "../canvas/CartItemsInCart";
import cartAPI from "../../api/cartApi";
import CouponList from "../others/CouponList";
import Breadcrump from "../../components/Breadcrump";
import { showError, showSuccess } from "../../utils/toastUtils";
import Summary from "./common/Summary";
import { handleApiValidationError } from "../../utils/apiErrorHandler";
import { ArrowRight } from "lucide-react";

function Cart() {
  const { cartItems, fetchCart, cartSummary } = useCart();

  const [couponList, setCouponList] = useState([]);
  const [couponCode, setCouponCode] = useState(cartSummary?.couponCode || "");

  useEffect(() => {
    fetchCouponCodes();
  }, []);

  useEffect(() => {
    setCouponCode(cartSummary?.couponCode || "");
  }, [cartSummary]);

  const fetchCouponCodes = async () => {
    try {
      const res = await cartAPI.showCoupon();
      if (res.code === 200) {
        setCouponList(res.data);
      }
    } catch (err) {}
  };
  // apply coupon

  const applyCoupon = async (codeParam) => {
    const codeToApply = codeParam || couponCode;

    try {
      const res = await cartAPI.applyCoupon({
        couponCode: codeToApply,
      });

      if (res.code === 200) {
        await fetchCart();
        showSuccess("Coupon applied successfully");
      } else {
        showError(res.message || "Invalid coupon code");
      }
    } catch (err) {
      handleApiValidationError(err, showError);
    }
  };

  const removeCoupon = async () => {
    try {
      const res = await cartAPI.removeCoupon();
      if (res.code === 200) {
        fetchCart();
        showSuccess("Coupon removed");
      }
    } catch (err) {}
  };

  return (
    <>
      <Breadcrump title="Cart" />

      <div className="s-contact flat-spacing-13">
        <div className="container">
          {cartItems && cartItems.length > 0 ? (
            <div className="row">
              <div className="col-xl-8">
                <div className="tf-page-cart-main">
                  <form className="form-cart">
                    {cartItems && (
                      <>
                        {cartItems.map((item) => (
                          <CartItemsInCart key={item._id} item={item} />
                        ))}

                        <div className="box-ip-discount">
                          <div className="discount-ip">
                            <input
                              className="value-discount"
                              type="text"
                              placeholder="Discount code"
                              value={couponCode}
                              onChange={(e) => setCouponCode(e.target.value)}
                            />
                            <button
                              type="button"
                              className="tf-btn radius-6 btn-out-line-dark-2"
                              onClick={
                                cartSummary?.couponCode
                                  ? removeCoupon
                                  : () => applyCoupon()
                              }
                            >
                              {cartSummary?.couponCode ? "Remove" : "Apply"}
                            </button>
                          </div>

                          {couponList && couponList.length > 0 && (
                            <div className="couponlist mt-3">
                              <div className="row mb-3">
                                {couponList.map((items, index) => (
                                  <div
                                    className="col-md-12 mb-3"
                                    key={items._id}
                                  >
                                    <CouponList
                                      key={items._id}
                                      item={items}
                                      isApplied={
                                        cartSummary?.couponCode === items.code
                                      }
                                      onApply={() => applyCoupon(items.code)}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </form>
                </div>
              </div>
              <div className="col-xl-4">
                <div className="summary-card">
                  <h3 className="font-serif mb-4 pb-3 border-bottom border-light border-opacity-25">
                    Order Summary
                  </h3>

                  <Summary cartItems={cartItems} cartSummary={cartSummary} />

                  <Link to="/checkout">
                    <button className="btn-checkout shadow-lg">
                       Checkout <ArrowRight size={16} className="ms-2" />
                    </button>
                  </Link>

                  <p className="text-center mt-3 small opacity-50">
                    Taxes and shipping calculated at checkout.
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="my-acount-content account-orders mb-5">
              <div className="account-orders-wrap">
                <div className="account-no-orders-wrap">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/section/account-no-order.png`}
                    alt="No Order Found"
                  />
                  <div className="display-sm fw-medium title">
                    You haven’t added any item in your cart yet
                  </div>
                  <Link
                    to="/shop"
                    className="tf-btn animate-btn d-inline-flex bg-dark-2 justify-content-center"
                  >
                    Shop Now
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Cart;
